import React from 'react'
import DefaultForm from '../../../../ui/forms/default-form'

const formValue = 'withdraw_case_claim'

const active = ({ available_actions = [] }) => available_actions.includes('withdraw_iss_case_claim')

const apiEndPoint = ({ record, iss_case }) =>
  [
    process.env.REACT_APP_API_HOST,
    'api',
    'iss-cases',
    iss_case.gov_id,
    'iss-case-claims',
    record.gov_id,
    'cancel',
  ].join('/')

const withdrawClaimForm = ({ record, iss_case }) => ({ handleSuccess }) => (
  <DefaultForm
    url={apiEndPoint({ record, iss_case })}
    name={formValue}
    label="Withdraw ISS Case Claim"
    handleSuccess={() =>
      handleSuccess({ [formValue]: 'The ISS Case claim has been withdrawn' }, formValue)
    }
    formComponent={() => (
      <fieldset>
        Once your ISS Claim has been withdrawn, you will need to recreate a new one to replace it
      </fieldset>
    )}
  />
)

const withdrawClaim = ({ record, iss_case, iss_case_claim, refresh_iss_case_claim }) =>
  active(record)
    ? {
        label: 'Withdraw Case Claim',
        value: formValue,
        actionForm: withdrawClaimForm({ record, iss_case_claim, iss_case }),
        onComplete: () => refresh_iss_case_claim(),
      }
    : null

export default withdrawClaim



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/withdraw-claim/index.js